import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";
import { useLanguage } from "@/i18n";

export default function Faq() {
  const { t } = useLanguage();
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-24 md:px-12 md:py-36">
      <SectionHead index={t.faq.index} overline={t.faq.overline} title={t.faq.title} align="center" testid="faq" />
      <Reveal delay={0.15} className="mt-14">
        <Accordion type="single" collapsible className="space-y-4">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-gold/15 bg-surface px-6 transition-colors duration-300 data-[state=open]:border-gold/50"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-serif text-lg text-[#FAFAFA] hover:text-gold hover:no-underline rtl:text-right"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-[#A3A3A3]">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
